import { setTranslationValues, useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { orderStatisticsCards } from '../../../../../helpers/orderStatisticsCards';
import { StatisticItem } from './statisticsItem';
import { statisticsDataStore } from '../../../../../store/statisticsStore';

const StatisticsWr = observer(() => {
  const {
    statisticsData: { percentages = {}, result = [] },
    getStatisticsData,
  } = statisticsDataStore;

  const t = useTranslation();

  useEffect(() => {
    getStatisticsData();
  }, []);

  return result.length ? (
    <div className='statistics-wrap'>
      <div className='game-statistics'>
        <div className='game-statistics-round'>
          <div className='game-statistics-round-inner'>
            <p className='game-statistics-round-title'>
              {setTranslationValues(t('LAST_VALUE_ROUNDS'), { value: 100 })}
            </p>
            <div className='statistics-procent'>
              <div className='s-procent-item left' style={{ width: `${percentages.red}%` }}>
                <span>{percentages.red}%</span>
              </div>
              <div className='s-procent-item right'>
                <span>{percentages.black}%</span>
              </div>
            </div>
          </div>
        </div>
        <div className='game-statistics-card'>
          <div className='scrollable-container'>
            <div className='game-statistics-card-inner'>
              {orderStatisticsCards([...result]).map((item) => (
                <StatisticItem key={item.name} name={item.name} coefficient={item.count} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
});

export default StatisticsWr;
